import loginEntryDownload from 'BASE/components/downLoad/loginEntryDownload';
import downloadCenterAndAFK from 'BASE/components/downLoad/DownLoadCenterAndAFK';
import { actionTypes } from 'BASE/store/types';

export default {
    mixins: [loginEntryDownload, downloadCenterAndAFK],
    props: {
        dialog: Object
    },
    data: function(){
        return {
            display: false,
            checkSettingComplete: true,
            AppDownloadType: {
                APP: 'APP',
                LEGEND: 'LEGEND',
                HANGING_UP: 'HANGING_UP',
                LOGIN: 'LOGIN',
            },
            currentDownloadType: 'APP',    
        };
    },
    methods: {
        async showDownloadCenter(){
            await this.$store.dispatch(actionTypes.AFK_CONFIG);
            this.Init2();
            this.display = true;
        },
        closeDownloadCenter(){
            this.display = false;
        },
        switchDownloadType(type){
            this.currentDownloadType = type;
        },
        GetAfkConfig(){
            return this.$store.state.userinfo.afkConfig;
        },
        copyLink(url) {
            let _this = this;
            _this.$copyText(url).then(() => {
                _this.$dialog.warning("已复制链接:" + url);
            }, () => {
                console.log("复制失败");
            });
        },
    }
}